import React, { useState } from "react";
import { tabsData } from "../Data";

function TabsItem() {
  const [currentTab, setCurrentTab] = useState(tabsData[0].id);

  const handleTabClick = (id) => {
    setCurrentTab(id); // Ensure id remains a number
  };

  return (
    <div className="tabs-item">
      {/* Tabs Navigation */}
      <div className="tabs">
        {tabsData.map((item) => (
          <button
            key={item.id} // Correct key placement
            onClick={() => handleTabClick(item.id)}
            disabled={currentTab === item.id} // Ensure type consistency
          >
            {item.tabTitle}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div>
        {tabsData.map((item) =>
          currentTab === item.id ? ( // Ensure proper comparison
            <div key={item.id} className="tab-content">
              <div className="tab-text-img">
                <div className="tab-text">
                  <img src={item.tabIcon} alt="" />
                  <h4>{item.headline}</h4>
                  <p className="text">{item.description}</p>
                </div>
                <img src={item.tabImage} alt="" className="tab-img" />
              </div>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
}

export default TabsItem;
